export default __webpack_public_path__ + "static/media/Mark-5-HUD-3D Model.56c0e41c.jpg";